import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import useNavigation from 'core/hooks/navigation/useNavigation'
import { AcceptInviteUrl, DashboardUrl } from 'constants/RouteUrls'

const SamlCallbackPage = () => {
  const { push } = useNavigation()
  const location = useLocation()
  const [initialLoad, setInitialLoad] = useState(true)

  const handleRedirect = useCallback(() => {
    const inviteToken = new URLSearchParams(location.search).get('invite_token')
    push(inviteToken ? AcceptInviteUrl : DashboardUrl)
  }, [location.search, push])

  useEffect(() => {
    const jwt = new URLSearchParams(location.search).get('jwt')
    if (!initialLoad) return
    if (!jwt) {
      handleRedirect()
      setInitialLoad(false)
    }
  }, [handleRedirect, initialLoad, location.search])
  return null
}
export default React.memo(SamlCallbackPage)
